import React, { Component } from 'react'
import {LegendSection} from './section'; 
import {ArrowToggle} from '../icons/index';
import PropTypes from 'prop-types'

class LegendComp extends Component {
	constructor(props){
		super(props);

		if(this.props.data.length === 0) {
			this.state = {open: false};
		} else {
			this.state = {open: true};
		}
		
	}
	clickHandler(){

		this.props.clickFunc();
	}
	openHandler(){

	//	this.props.openHandler();
		
		this.setState({open: (!this.state.open)});
	}
	renderData(){

		if(!this.state.open) {
			return null;
		}

		var sectionStyle = {float:'left', padding:'2px 4px 2px 2px'};
		var n = 0;
		var sections = this.props.data.map(function(elem){

			return (<div key={n++} style={sectionStyle}>
				<LegendSection 
				color={elem.color} 
				border={(elem.border ? elem.border : null)} 
				stripes={elem.stripes}  
				text={elem.text}/></div>);
		});

		return (<div style={{paddingRight: '10px'}}>
        	{sections}
        	<div style={{clear: 'both'}}></div>
        </div>);
	}
	render() {

		if(!this.props.enabled) {

			return null;
		}

	    return (
	    	<div style={{
	    		padding: '2px', 
	    		backgroundColor: 'rgba(255, 255, 255, 0.8)', 
	    		maxWidth: '404px', 
	    		minHeight: '40px',
	    		boxShadow: 'rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px',
	    	}}>
		        <div style={(this.state.open ? {position: 'absolute', width: '30px', top: 0, right: 0} : {float: 'right'})}>
		        	{!this.state.open ? (
		        		<span style={{padding: '0 0 0 6px', cursor: 'pointer'}} onClick={this.openHandler.bind(this)}> {this.state.open ? '' : 'Leģenda'} </span>
		        	) : null}
			        <ArrowToggle 
				        onClick={this.openHandler.bind(this)}
				        style={{
				        	cursor: 'pointer',
				        	height: '20px',
				        	margin: '6px 0 0 6px',
				        	width: '20px',
				        	transform: (this.state.open ? 'rotate(270deg)' : 'rotate(90deg)')
				        }}
			        />
		        </div>
		        {this.renderData()}
	      	</div>
	   	);
	}
}

LegendComp.propTypes = {
	data: PropTypes.array
};

export {LegendComp}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/legend/index.js